import { stitch } from 'keo';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import PropTypes from 'prop-types';
import r from 'render-dom';

import CircularProgress from 'material-ui/CircularProgress';

const propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    submitting: PropTypes.bool.isRequired,
};

const render = ({ props: { label, onClick, raised, style = {}, submitting } }) => {
    return (
        r(raised ? RaisedButton : FlatButton, {
            disabled: submitting,
            label: submitting
                ? r(CircularProgress, { size: 30 })
                : label,
            onClick,
            primary: raised ? null : true,
            secondary: raised ? true : null,
            style,
            type: 'submit',
        })
    );
};

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/components/shared/buttons/FormButton/index.js